import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import UserTypes from "components/auth/user-types";
import TabWorkerMainInfo from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-main-info";
import TabWorkerContactInfo from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-contact-info";
import TabWorkerProfileInfo from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-profile-info";
import TabTabWorkerAvailability from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-availability";
import TabWorkerComments from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-comments";
import TabWorkerScheduledWork from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-scheduled-work";
import TabWorkerPayroll from "components/menu/master-files/workers-maintenance/worker-profile-components/tab-worker-payrole";
import {
    setEmployee,
    fetchEmployeeAvailability,
    setEmployeeAvailability,
    fetchEmployeeScheduledWork,
    setEmployeeScheduledWork,
    removeSingleEmployee,
} from "actions/employeeActions";
import {
    getWorkerFullById,
    insertWorker,
    updateWorker,
} from "api/menu/master-files/workers-maintenance/actions";

class WorkerProfile extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);

        const { workerId } = this.props;

        if (workerId) {
            this.props.getWorkerFullById(workerId);
        }

        this.tabsKeys = {
            ContactInfo: "ContactInfo",
            Profile: "Profile",
            Availability: "Availability",
            Comments: "Comments",
            ScheduledWork: "ScheduledWork",
            Payroll: "Payroll",
        };

        const singleEmployee = {};
        Object.keys(this.tabsKeys).forEach(key => {
            singleEmployee[key] = {};
        });

        this.state = {
            tabKey: this.tabsKeys.ContactInfo,
            showValidation: false,
            singleEmployee
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            singleEmployee: nextProps.singleEmployee
        });
    }

    componentWillUnmount() {
        this.props.removeSingleEmployee();
    }

    handleChange = (ev, tabKey) => {
        const singleEmployee = Object.assign({}, this.state.singleEmployee);
        singleEmployee[tabKey] = Object.assign({}, singleEmployee[tabKey]);

        if (Array.isArray(ev)) {
            ev.forEach(item => {
                const { name, value } = item;
                singleEmployee[tabKey][name] = value;
            });

            this.setState({
                singleEmployee
            });
            return;
        }

        const { name, value, type } = ev.target;
        if (name === "languages") {
            const languages = Object.assign([], singleEmployee[tabKey].languages);
            const currentLanguageIndex = languages.findIndex(item => item.languageId === value.id);
            if (currentLanguageIndex > -1) {
                if (value.isSpoken) {
                    languages[currentLanguageIndex].isSpoken = value.value;
                } else {
                    languages[currentLanguageIndex].isWritten = value.value;
                }

                if (!languages[currentLanguageIndex].isWritten
                    && !languages[currentLanguageIndex].isSpoken) {
                    languages.splice(currentLanguageIndex, 1);
                }
            } else {
                languages.push({
                    languageId: value.id,
                    language: value.name,
                    isSpoken: value.isSpoken ? value.value : false,
                    isWritten: !value.isSpoken ? value.value : false,
                });
            }
            singleEmployee[tabKey].languages = languages;
        } else if (name === "positionsApplied") {
            const positionsApplied = Object.assign([], singleEmployee[tabKey].positionsApplied);
            const currentPositionsAppliedIndex =
                positionsApplied.findIndex(item => item.id === value.id);
            if (currentPositionsAppliedIndex > -1) {
                positionsApplied.splice(currentPositionsAppliedIndex, 1);
            } else {
                positionsApplied.push({
                    id: value.id,
                    value: value.value
                });
            }
            singleEmployee[tabKey].positionsApplied = positionsApplied;
        } else if (type === "checkbox") {
            singleEmployee[tabKey][name] = (value === "on");
        } else {
            singleEmployee[tabKey][name] = value;
        }

        this.setState({
            singleEmployee
        });
    };

    handleSave = () => {
        const { singleEmployee } = this.state;
        /*
        const data = {
            account: ""
            address1: "82 Harmony Road"
            address2: ""
            bank: ""
            city: "Thornhill"
            cityId: 5909
            code: "DEBBIE"
            contractSigned: false
            country: "Canada"
            countryId: 1
            currentSalary: null
            dateStarted: "2010-12-13T00:00:00"
            email: "DEBBIE@example.com"
            employmentStatus: null
            employmentStatusId: 0
            employmentType: null
            employmentTypeId: 0
            extras: ""
            fax: ""
            faxCallFirst: false
            faxNeedCoverSheet: false
            firstName: "Debbie"
            gstNumber: ""
            helper: ""
            helperInfo: ""
            homePhone: "6472835290"
            hourlyRate: null
            hoursAvailable: null
            id: 1
            inactive: false
            isAccountManager: true
            isAdministrator: false
            isAlternateAddress: false
            isCrmUser: false
            isHelper: false
            isHrRestricted: true
            isMerchandiser: false
            isSpecialProjects: false
            isSupervisor: false
            languages: []
            lastName: "Chrysanthou"
            lastWorkedDate: null
            minHourlyRate: 0
            minimumHours: null
            mobilePhone: ""
            officeExt: ""
            officePhone: ""
            payableTo: ""
            policyDiscussed: false
            positionsApplied: []
            postalCode: "L4K 5G4"
            province: "Ontario"
            provinceId: 9
            resumeEnteredDate: null
            sin: ""
            subContractSigned: false
            supervisorId: 0
            supervisorName: null
            transit: ""


            isOnlinePayrol: false +
            isPayrollOnHold: false
            isGstApplicable: false
            travelChargePerKm: 0
        };
        */

        const data = {
            ...singleEmployee.ContactInfo
        };

        let validateManually = true;
        if (this.getEmployeeValue("firstName", this.tabsKeys.ContactInfo) === "") {
            validateManually = false;
        } else if (this.getEmployeeValue("lastName", this.tabsKeys.ContactInfo) === "") {
            validateManually = false;
        } else if (
            !this.getEmployeeValue("isMerchandiser", this.tabsKeys.ContactInfo, false)
            // && !this.getEmployeeValue("isSupervisor", this.tabsKeys.ContactInfo, false)
            && !this.getEmployeeValue("isAdministrator", this.tabsKeys.ContactInfo, false)
            && !this.getEmployeeValue("isAccountManager", this.tabsKeys.ContactInfo, false)
        ) {
            validateManually = false;
        } else if (
            this.getEmployeeValue("isMerchandiser", this.tabsKeys.ContactInfo, false)
            && !this.getEmployeeValue("supervisorId", this.tabsKeys.ContactInfo, false)
        ) {
            validateManually = false;
        }

        if (validateManually) {
            if (this.props.workerId) {
                data.id = this.props.workerId;
                this.props.updateWorker(this.props.workerId, data);
            } else {
                this.props.insertWorker(data);
            }
            if (this.props.onSave) {
                this.props.onSave();
            }
        } else {
            this.setState({
                showValidation: true
            });
        }
    };

    changeTab = tabKey => {
        const needRequest = typeof this.state.singleEmployee[tabKey] === "undefined";
        const {
            workerId,
            fetchEmployeeAvailability,
            fetchEmployeeScheduledWork,
        } = this.props;

        if (needRequest && workerId) {
            switch (tabKey) {
                case this.tabsKeys.Availability:
                    fetchEmployeeAvailability(workerId);
                    break;
                case this.tabsKeys.ScheduledWork:
                    fetchEmployeeScheduledWork(workerId);
                    break;
                default:
                    break;
            }
        }

        this.setState({
            tabKey
        });
    };

    getEmployeeValue = (propName, tabKey = false, defaultValue = "") => {
        const { singleEmployee } = this.state;

        if (tabKey !== false && singleEmployee[tabKey] && typeof singleEmployee[tabKey][propName] !== "undefined") {
            return singleEmployee[tabKey][propName];
        }
        if (typeof singleEmployee[propName] !== "undefined") {
            return singleEmployee[propName];
        }
        return defaultValue;
    };

    render () {
        const { auth, isEditable, workerId } = this.props;
        const { role } = auth.user;
        const { singleEmployee, showValidation } = this.state;

        return (
            <div>
                <TabWorkerMainInfo
                    workerId={workerId}
                    tabKey={this.tabsKeys.ContactInfo}
                    getEmployeeValue={this.getEmployeeValue}
                    onChange={this.handleChange}
                    isEditable={isEditable}
                    singleEmployee={singleEmployee}
                    showValidation={showValidation}
                    auth={auth}
                />

                <div className="mt-2">
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={this.state.tabKey}
                        onSelect={this.changeTab}
                    >
                        <Tab eventKey={this.tabsKeys.ContactInfo} title="Contact Info">
                            <TabWorkerContactInfo
                                workerId={workerId}
                                tabKey={this.tabsKeys.ContactInfo}
                                getEmployeeValue={this.getEmployeeValue}
                                onChange={this.handleChange}
                                isEditable={isEditable}
                                singleEmployee={singleEmployee}
                                showValidation={showValidation}
                            />
                        </Tab>

                        {!role.includes(UserTypes.supervisor) ?
                        <Tab eventKey={this.tabsKeys.Profile} title="Profile">
                            <TabWorkerProfileInfo
                                workerId={workerId}
                                tabKey={this.tabsKeys.ContactInfo}
                                getEmployeeValue={this.getEmployeeValue}
                                onChange={this.handleChange}
                                isEditable={isEditable}
                                singleEmployee={singleEmployee}
                                showValidation={showValidation}
                            />
                        </Tab>
                        : null}

                        <Tab eventKey={this.tabsKeys.Availability} title="Availability">
                            <TabTabWorkerAvailability
                                workerId={workerId}
                                tabKey={this.tabsKeys.Availability}
                                getEmployeeValue={this.getEmployeeValue}
                                onChange={this.handleChange}
                                singleEmployee={singleEmployee}
                                showValidation={showValidation}
                            />
                        </Tab>

                        {role.includes(UserTypes.admin) ?
                            <Tab eventKey={this.tabsKeys.Comments} title="Comments">
                                <TabWorkerComments
                                    workerId={workerId}
                                    tabKey={this.tabsKeys.Comments}
                                    getEmployeeValue={this.getEmployeeValue}
                                    onChange={this.handleChange}
                                    isEditable={isEditable}
                                    singleEmployee={singleEmployee}
                                    showValidation={showValidation}
                                />
                            </Tab>
                            : null}

                        {isEditable ?
                            <Tab eventKey={this.tabsKeys.Payroll} title="Payroll">
                                <TabWorkerPayroll
                                    isEditable={isEditable}
                                    workerId={workerId}
                                    tabKey={this.tabsKeys.ContactInfo}
                                    getEmployeeValue={this.getEmployeeValue}
                                    onChange={this.handleChange}
                                    singleEmployee={singleEmployee}
                                    showValidation={showValidation}
                                />
                            </Tab>
                            : null}

                        <Tab eventKey={this.tabsKeys.ScheduledWork} title="Scheduled Work">
                            <TabWorkerScheduledWork
                                workerId={workerId}
                                tabKey={this.tabsKeys.ScheduledWork}
                                getEmployeeValue={this.getEmployeeValue}
                                onChange={this.handleChange}
                                singleEmployee={singleEmployee}
                                showValidation={showValidation}
                            />
                        </Tab>

                    </Tabs>
                </div>

                {isEditable ?
                    <div className="mt-2 text-right">
                        <button className="btn btn-success" onClick={this.handleSave}>
                            Save
                        </button>
                    </div>
                    : null}
            </div>
        );
    }
}

WorkerProfile.defaultProps = {
    isEditable: false,
    workerId: false,
};

WorkerProfile.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    isEditable: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    singleEmployee: state.employee.singleEmployee,
});

const mapStateToDispatch = dispatch => ({
    setEmployee: bindActionCreators(setEmployee, dispatch),
    fetchEmployeeAvailability: bindActionCreators(fetchEmployeeAvailability, dispatch),
    setEmployeeAvailability: bindActionCreators(setEmployeeAvailability, dispatch),
    fetchEmployeeScheduledWork: bindActionCreators(fetchEmployeeScheduledWork, dispatch),
    setEmployeeScheduledWork: bindActionCreators(setEmployeeScheduledWork, dispatch),
    removeSingleEmployee: bindActionCreators(removeSingleEmployee, dispatch),
    getWorkerFullById: bindActionCreators(getWorkerFullById, dispatch),
    insertWorker: bindActionCreators(insertWorker, dispatch),
    updateWorker: bindActionCreators(updateWorker, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(WorkerProfile);
